// hooks/useExportData.js
import { useState } from "react";
import {
    prepareExportData,
    exportToCSV,
    exportToExcel,
} from "../Utils/exportUtils";
import { App } from "antd";
import Axios from "axios";
import consts from "../constant";

const ALLOWED_CATEGORIES = [
    "users",
    "deposits",
    "withdrawals",
    "wallets",
    "currencies",
    "networks",
    "kyc",
    "trades",
    "transactions",
];

export const exportDataApi = async ({ category, filters = {}, fields = [] }) => {
    try {
        if (!ALLOWED_CATEGORIES.includes(category)) {
            throw new Error("Invalid export category");
        }

        const params = {
            category,
            ...filters,
        };

        if (fields.length) {
            params.fields = fields.join(",");
        }

        const res = await Axios.get(`${consts.BackendUrl}/export`, {
            params, headers: {
                Authorization: `Bearer ${localStorage.getItem("Jetix")}`,
            }
        },);

        return res.data;
    } catch (err) {
        console.error("Export API error:", err);
        throw err;
    }
};

export const useExportData = () => {

    const { message } = App.useApp();
    const [loading, setLoading] = useState(false);

    const handleExport = async ({
        category,
        filters,
        fields,
        type = "csv",
    }) => {
        try {
            setLoading(true);

            const res = await exportDataApi({ category, filters, fields });

            const rawData = res?.data || [];

            if (!rawData.length) {
                message.warning("No data available to export");
                return;
            }

            const formattedData = prepareExportData(rawData);

            const fileName = `${category}_${new Date().toISOString()}`;

            if (type === "excel") {
                exportToExcel(formattedData, `${fileName}.xlsx`);
            } else {
                exportToCSV(formattedData, `${fileName}.csv`);
            }

            message.success("Export successful");
        } catch (err) {
            message.error(err.message || "Export failed");
        } finally {
            setLoading(false);
        }
    };

    return { handleExport, loading };
};